/**
 * Project — a case study, told front then back: the opening, the overview,
 * the front, the back and the next shop on the street. The server writes it
 * (templates/site/project.html.twig); this moves it.
 *
 * @module pages/project
 */

import { $ } from '../lib/dom.js';
import { pageEntry } from '../lib/page-data.js';
import { awardBadge } from '../components/shop.js';
import * as back from '../sections/project/back.js';
import * as front from '../sections/project/front.js';
import * as next from '../sections/project/next.js';
import * as opening from '../sections/project/opening.js';

/** The official badge of the project's award, fixed on the right edge ("pages/project"). */
export function rail() {
    return { badge: awardBadge(pageEntry('pages/project').award, 'fixed') };
}

export function animate() {
    opening.animate($('#case'));
    front.animate();
    back.animate();

    const nextShop = $('#next');

    if (nextShop) {
        next.animate(nextShop);
    }
}
